<div class="modal-header">
    <h5 *ngIf="mode == 1" class="modal-title">Add {{(!this.selectedFolder)?'Root ':'Sub-'}}Folder</h5>
    <h5 *ngIf="mode == 2" class="modal-title">Rename Folder</h5>
    <span class="fa fa-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></span>
</div>
<div class="modal-body">
    <form [formGroup]="folderForm">
        <div class="form-group">
            <label for="folderInput">{{(!this.selectedFolder)?'Root ':'Sub-'}}Folder Name<span class="required-text">*</span></label>
            <input type="text" formControlName="name" class="form-control" id="folderInput">
        </div>
    </form>
</div>
<div class="modal-footer">
    <button *ngIf="mode == 1" type="button" class="btn btn-primary" [disabled]="!folderForm.valid" (click)="submitForm(mode)">Add</button>
    <button *ngIf="mode == 2" type="button" class="btn btn-primary" [disabled]="!folderForm.valid" (click)="submitForm(mode)">Rename</button>
    <button type="button" class="btn btn-default" (click)="activeModal.close()">Cancel</button>
</div>